import type { ChangelogEntry } from "../types";

/** CRM fase 1: kundekort v2 med status, eiere, kontaktpersoner, kontaktlogg og e-post fra Revehiet. */
export const CRM_KUNDEKORT_2026_10: ChangelogEntry = {
  id: "2026-10-17-crm-kundekort",
  date: "2026-10-17",
  title: "Kundekortet har fått status, kontaktpersoner og kontaktlogg",
  summary:
    "Kundekortet viser nå om kunden er varm, medium eller kald, hvem som eier kunden, hvem du kan kontakte og hva som er sagt og sendt. Du kan sende e-post fra din egen Gmail rett fra kortet.",
  sections: [
    {
      heading: "Kundekortet",
      items: [
        {
          title: "Kundestatus: varm, medium eller kald",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Øverst på kundekortet og i kundelisten ser du om kunden er varm (har kjøpt de siste to årene), medium eller kald (har aldri fått tilbud). En forklaring i klartekst står ved siden av. Trenger du å avvike fra utregningen, kan du overstyre statusen med en begrunnelse og en dato den gjelder til.",
        },
        {
          title: "Eiere på kunden",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Kunden har nå eiere, hentet fra salgseierne på prosjektene. Står en salgsenhet med to personer, blir begge eiere. Du kan endre eierne fra kundekortet, og endringen logges med forrige og nytt sett.",
        },
        {
          title: "Kontaktpersoner med rolle",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Under «Kontaktpersoner» legger du til flere personer per kunde med tittel, e-post og mobil, og velger hvem som er hovedkontakt. «Slett person» fjerner navn og kontaktinfo for godt, men beholder samtalene i loggen.",
        },
        {
          title: "Nøkkeltall for kunden",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Fire tall øverst: verdi solgt, brutto fortjeneste (GEEK), snitt timepris og feilbudsjettering. Tallene bruker de samme formlene som dashboardet. Mangler grunnlaget, for eksempel fordi kunden ikke har avsluttede prosjekter, står det «–».",
        },
      ],
    },
    {
      heading: "Kontaktlogg og e-post",
      items: [
        {
          title: "Kontaktlogg på kunden",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Samtaler, notater og e-post samles i en tidslinje gruppert per dag. Bruk «Logg samtale» og «Logg notat» for det du ellers ville husket selv.",
        },
        {
          title: "Send e-post fra kundekortet",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "«Send e-post» sender meldingen fra din egen Gmail-konto til en kontaktperson. Svar fra kunden dukker opp i kontaktloggen innen fem minutter. Skriver du utenfor arbeidstid, i helg eller på en rød dag, planlegges meldingen til neste mulige tidspunkt (aldri før 08:00), og kortet sier når den går.",
        },
      ],
    },
  ],
};
